import { useEffect, useRef } from 'react';

// The check runs when the browser asks (reload, tab close), so it reads the live buffers
// and never a stale render; a clean page gets no prompt. Leaving inside the app is
// handled by the pages' own flush on leave.
export function useUnsavedEditsWarning(hasUnsaved: () => boolean) {
  const checkRef = useRef(hasUnsaved);
  useEffect(() => {
    checkRef.current = hasUnsaved;
  });
  useEffect(() => {
    const warn = (e: BeforeUnloadEvent) => {
      if (!checkRef.current()) return;
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, []);
}
